import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateValuationSettings, ValuationSettings } from '../../../api/ValuationSettings/valuationSettings';

export function useUpdateValuationSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (valuationSettings: ValuationSettings) => updateValuationSettings(valuationSettings),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ 'getValuationSettings' ] });
    },
  });
}
